"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FORMULA_OPTIONS: function() {
        return FORMULA_OPTIONS;
    },
    QueryBarSk: function() {
        return QueryBarSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _repeat = require("lit/directives/repeat.js");
const _fuzzy = require("./fuzzy");
require("./multi-select-sk");
require("@material/web/textfield/outlined-text-field");
require("@material/web/iconbutton/icon-button");
require("@material/web/icon/icon");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _QueryBarSk;
function calculatePillFocusIndex(clientX, clientY, containerRect, pillRects) {
    const isAbove = containerRect && clientY < containerRect.top;
    if (isAbove) {
        return 0;
    } else {
        let lastPillInRow = null;
        for (const pr of pillRects){
            if (clientY >= pr.top && clientY <= pr.bottom) {
                lastPillInRow = pr;
                if (clientX <= pr.right) {
                    return pr.index;
                }
            }
        }
        if (lastPillInRow) {
            return lastPillInRow.index;
        }
        if (pillRects.length > 0) {
            return pillRects[pillRects.length - 1].index;
        }
    }
    return -1;
}
const FORMULA_OPTIONS = [
    {
        id: 'fill',
        name: 'fill()',
        desc: 'Fill missing data points',
        category: 'prep'
    },
    {
        id: 'iqrr',
        name: 'iqrr()',
        desc: 'Remove outliers (IQR)',
        category: 'prep'
    },
    {
        id: 'ave',
        name: 'ave()',
        desc: 'Average matching traces',
        category: 'agg'
    },
    {
        id: 'sum',
        name: 'sum()',
        desc: 'Sum matching traces',
        category: 'agg'
    },
    {
        id: 'min',
        name: 'min()',
        desc: 'Minimum value across traces',
        category: 'agg'
    },
    {
        id: 'max',
        name: 'max()',
        desc: 'Maximum value across traces',
        category: 'agg'
    },
    {
        id: 'count',
        name: 'count()',
        desc: 'Count non-missing values',
        category: 'agg'
    },
    {
        id: 'geo',
        name: 'geo()',
        desc: 'Geometric mean across traces',
        category: 'agg'
    },
    {
        id: 'norm',
        name: 'norm()',
        desc: 'Normalize (mean 0, stddev 1)',
        category: 'trans'
    },
    {
        id: 'log',
        name: 'log()',
        desc: 'Base-10 logarithm',
        category: 'trans'
    },
    {
        id: 'step',
        name: 'step()',
        desc: 'Step detection ratio',
        category: 'trans'
    },
    {
        id: 'scale_by_ave',
        name: 'scale_by_ave()',
        desc: 'Scale by 1/average',
        category: 'trans'
    },
    {
        id: 'trace_ave',
        name: 'trace_ave()',
        desc: 'Trace mean timeline',
        category: 'trans'
    },
    {
        id: 'trace_stddev',
        name: 'trace_stddev()',
        desc: 'Trace standard deviation',
        category: 'trans'
    },
    {
        id: 'trace_cov',
        name: 'trace_cov()',
        desc: 'Coefficient of variation',
        category: 'trans'
    }
];
let QueryBarSk = (_QueryBarSk = class QueryBarSk extends _lit.LitElement {
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('mousedown', this._handleClickOutside);
        document.addEventListener('selectionchange', this._handleSelectionChange);
    }
    disconnectedCallback() {
        document.removeEventListener('mousedown', this._handleClickOutside);
        document.removeEventListener('selectionchange', this._handleSelectionChange);
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has('query') || changedProperties.has('availableParams') || changedProperties.has('optionsByKey') || changedProperties.has('_inputValue') || changedProperties.has('externalSuggestions')) {
            this._updateSuggestions();
        }
        if (changedProperties.has('_isOpen') && this._isOpen) {
            this._scrollFocusedIntoView();
        }
    }
    _sortKeys(keys) {
        const order = this.includeParams || [];
        return [
            ...keys
        ].sort((a, b)=>{
            const indexA = order.indexOf(a);
            const indexB = order.indexOf(b);
            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;
            return a.localeCompare(b);
        });
    }
    _getAvailableKeys() {
        const keys = Object.keys(this.optionsByKey).filter((k)=>!this.query[k]);
        return this._sortKeys(keys);
    }
    _getPlaceholderTip() {
        const keys = this._getAvailableKeys();
        if (keys.length === 0) return 'All filters applied.';
        return `Filter by: ${[
            ...keys
        ].sort().join(', ')}`;
    }
    _getAllParams() {
        const apMap = new Map();
        (this.availableParams || []).forEach((p)=>{
            var _p_count;
            apMap.set(`${p.key}=${p.value}`, (_p_count = p.count) !== null && _p_count !== void 0 ? _p_count : 0);
        });
        const list = [];
        Object.keys(this.optionsByKey || {}).forEach((k)=>{
            (this.optionsByKey[k] || []).forEach((o)=>{
                var _apMap_get;
                const count = (_apMap_get = apMap.get(`${k}=${o.value}`)) !== null && _apMap_get !== void 0 ? _apMap_get : 0;
                list.push({
                    key: k,
                    value: o.value,
                    count
                });
            });
        });
        return list;
    }
    _updateSuggestions() {
        const trimmed = this._inputValue.trim();
        if (!trimmed) {
            this.externalSuggestions = null;
            if (this._isOpen) {
                if (!this._selectedCategory) {
                    const keys = Object.keys(this.optionsByKey).filter((k)=>!this.query[k]);
                    this._suggestions = keys.map((k)=>{
                        let totalCount = 0;
                        if (this.availableParams && this.availableParams.length > 0) {
                            var _p_count;
                            totalCount = this.availableParams.filter((p)=>p.key === k).reduce((sum, p)=>sum + ((_p_count = p.count) !== null && _p_count !== void 0 ? _p_count : 0), 0);
                        } else {
                            const options = this.optionsByKey[k] || [];
                            totalCount = options.reduce((sum, o)=>sum + o.count, 0);
                        }
                        return {
                            params: [
                                {
                                    key: k,
                                    value: ''
                                }
                            ],
                            score: 100,
                            count: totalCount,
                            countIsLowerBound: false
                        };
                    }).filter((s)=>s.count > 0);
                    // Sort by include_params order, then by count descending
                    const order = this.includeParams || [];
                    this._suggestions.sort((a, b)=>{
                        const keyA = a.params[0].key;
                        const keyB = b.params[0].key;
                        const indexA = order.indexOf(keyA);
                        const indexB = order.indexOf(keyB);
                        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                        if (indexA !== -1) return -1;
                        if (indexB !== -1) return 1;
                        var _a_count;
                        const aCount = (_a_count = a.count) !== null && _a_count !== void 0 ? _a_count : 0;
                        var _b_count;
                        const bCount = (_b_count = b.count) !== null && _b_count !== void 0 ? _b_count : 0;
                        if (bCount !== aCount) return bCount - aCount;
                        return keyA.localeCompare(keyB);
                    });
                } else {
                    const cat = this._selectedCategory;
                    const apMap = new Map();
                    if (this.availableParams && this.availableParams.length > 0) {
                        this.availableParams.forEach((p)=>{
                            var _p_count;
                            if (p.key === cat) apMap.set(p.value, (_p_count = p.count) !== null && _p_count !== void 0 ? _p_count : 0);
                        });
                    }
                    const options = this.optionsByKey[cat] || [];
                    var _apMap_get;
                    this._suggestions = options.map((o)=>({
                            params: [
                                {
                                    key: cat,
                                    value: o.value
                                }
                            ],
                            score: 100,
                            count: this.availableParams && this.availableParams.length > 0 ? (_apMap_get = apMap.get(o.value)) !== null && _apMap_get !== void 0 ? _apMap_get : 0 : o.count,
                            countIsLowerBound: false
                        })).filter((s)=>s.count > 0);
                }
            } else {
                this._suggestions = [];
            }
            return;
        }
        if (this.externalSuggestions !== null && this.externalSuggestions.length > 0) {
            this._suggestions = this.externalSuggestions;
            return;
        }
        console.log('[_updateSuggestions] trimmed:', trimmed, 'availableParams count:', this.availableParams.length);
        if (trimmed.includes(' ')) {
            const tokens = trimmed.split(' ').map((s)=>s.trim()).filter(Boolean);
            if (tokens.length === 0) {
                this._suggestions = [];
                return;
            }
            const scored = this._getAllParams().filter((p)=>{
                var _this_query_p_key;
                return !((_this_query_p_key = this.query[p.key]) === null || _this_query_p_key === void 0 ? void 0 : _this_query_p_key.includes(p.value)) && (p.count === undefined || p.count > 0);
            }).map((p)=>{
                let bestScore = -Infinity;
                for (const token of tokens){
                    const s = (0, _fuzzy.scoreParamAny)(p, token);
                    if (s > bestScore) {
                        bestScore = s;
                    }
                }
                return {
                    p,
                    score: bestScore
                };
            });
            const matches = scored.filter((s)=>s.score > -Infinity);
            matches.sort((a, b)=>b.score - a.score);
            this._suggestions = matches.slice(0, _fuzzy.MAX_SUGGESTIONS).map((s)=>({
                    params: [
                        s.p
                    ],
                    score: s.score,
                    count: s.p.count,
                    countIsLowerBound: false
                }));
            return;
        }
        const eqIdx = trimmed.indexOf('=');
        const vPartCheck = eqIdx !== -1 ? trimmed.substring(eqIdx + 1) : trimmed;
        const hasGlobChar = vPartCheck.includes('*') || vPartCheck.includes('?') || vPartCheck.includes(',');
        const isGlobSearch = hasGlobChar;
        if (isGlobSearch) {
            const kPart = eqIdx !== -1 ? trimmed.substring(0, eqIdx) : '';
            const vPart = eqIdx !== -1 ? trimmed.substring(eqIdx + 1) : trimmed;
            if (!vPart) {
                this._suggestions = [];
                return;
            }
            try {
                const parts = vPart.split(',').map((s)=>s.trim()).filter(Boolean);
                const regexes = parts.map((part)=>{
                    const escaped = part.replace(/[.+^${}()|[\]\\]/g, '\\$&');
                    const pattern = '^' + escaped.replace(/\*/g, '.*').replace(/\?/g, '.') + '$';
                    return new RegExp(pattern, 'i');
                });
                const globSuggestions = [];
                for (const key of Object.keys(this.optionsByKey)){
                    if (this.query[key]) continue;
                    const keyScore = kPart ? (0, _fuzzy.fuzzyScore)(key, kPart) : 0;
                    if (kPart && keyScore === -Infinity) continue;
                    let totalCount = 0;
                    let matchesAnything = false;
                    const apMap = new Map();
                    if (this.availableParams && this.availableParams.length > 0) {
                        this.availableParams.forEach((p)=>{
                            var _p_count;
                            if (p.key === key) apMap.set(p.value, (_p_count = p.count) !== null && _p_count !== void 0 ? _p_count : 0);
                        });
                    }
                    for (const opt of this.optionsByKey[key]){
                        const matches = regexes.some((r)=>r.test(opt.value));
                        if (matches) {
                            var _apMap_get1;
                            const c = this.availableParams && this.availableParams.length > 0 ? (_apMap_get1 = apMap.get(opt.value)) !== null && _apMap_get1 !== void 0 ? _apMap_get1 : 0 : opt.count;
                            if (c > 0) {
                                matchesAnything = true;
                                totalCount += c;
                            }
                        }
                    }
                    if (matchesAnything) {
                        globSuggestions.push({
                            params: [
                                {
                                    key,
                                    value: vPart
                                }
                            ],
                            score: keyScore + 1000,
                            count: totalCount,
                            countIsLowerBound: false
                        });
                    }
                }
                globSuggestions.sort((a, b)=>b.score - a.score);
                this._suggestions = globSuggestions.slice(0, _fuzzy.MAX_SUGGESTIONS);
                return;
            } catch (_e) {
                this._suggestions = [];
                return;
            }
        }
        const scored = this._getAllParams().filter((p)=>{
            var _this_query_p_key;
            return !((_this_query_p_key = this.query[p.key]) === null || _this_query_p_key === void 0 ? void 0 : _this_query_p_key.includes(p.value)) && (p.count === undefined || p.count > 0);
        }).map((p)=>{
            return {
                p,
                score: (0, _fuzzy.scoreParamAny)(p, trimmed)
            };
        });
        const matches = scored.filter((s)=>s.score > -Infinity);
        console.log('[_updateSuggestions] matches count:', matches.length);
        this._boostPriorityScores(matches);
        matches.sort((a, b)=>b.score - a.score);
        this._suggestions = matches.slice(0, _fuzzy.MAX_SUGGESTIONS).map((s)=>({
                params: [
                    s.p
                ],
                score: s.score,
                count: s.p.count,
                countIsLowerBound: false
            }));
        void this._fetchCountsForSuggestions();
    }
    _boostPriorityScores(matches) {
        var _this_defaults;
        const priorities = (_this_defaults = this.defaults) === null || _this_defaults === void 0 ? void 0 : _this_defaults.default_trigger_priority;
        if (!priorities) return;
        matches.forEach((m)=>{
            const priorityValues = priorities[m.p.key];
            if (priorityValues && priorityValues.includes(m.p.value)) {
                m.score += 1000; // Boost score
            }
        });
    }
    async _fetchCountsForSuggestions() {
    // Rely on worker-provided counts
    }
    async _handleMultiSelectOpen(_key) {
        this._isOpen = false;
    // Rely on worker-provided counts
    }
    _isPillHighlighted(idx) {
        return this._selectedPills.has(idx);
    }
    _handlePillClick(e, idx) {
        // Always stop propagation to prevent focusing the input and opening query bar suggestions
        e.stopPropagation();
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
            var _this__inputElement;
            e.preventDefault();
            if (e.shiftKey && this._selectionAnchor !== null) {
                // Shift+Click: select range from anchor to clicked idx
                const start = Math.min(this._selectionAnchor, idx);
                const end = Math.max(this._selectionAnchor, idx);
                const newSelection = new Set();
                for(let i = start; i <= end; i++){
                    newSelection.add(i);
                }
                this._selectedPills = newSelection;
                this._selectionFocus = idx;
            } else {
                // Ctrl+Click or Cmd+Click: toggle individual pill
                const newSelection = new Set(this._selectedPills);
                if (newSelection.has(idx)) {
                    newSelection.delete(idx);
                } else {
                    newSelection.add(idx);
                }
                this._selectedPills = newSelection;
                this._selectionAnchor = idx;
                this._selectionFocus = idx;
            }
            (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.focus();
        } else {
            // Normal click: clear selection, let the pill handle its own click (open dropdown)
            this._selectedPills = new Set();
            this._selectionAnchor = null;
            this._selectionFocus = null;
        }
    }
    _handlePointerDownInput(e) {
        this._isDragging = true;
        this._dragStartPos = {
            x: e.clientX,
            y: e.clientY
        };
        this._startedInInput = true;
        const target = e.currentTarget;
        target.setPointerCapture(e.pointerId);
        const pills = this.renderRoot.querySelectorAll('explore-multi-v2-select-sk');
        const rects = [];
        pills.forEach((pill)=>{
            const index = parseInt(pill.getAttribute('data-index') || '-1');
            const rect = pill.getBoundingClientRect();
            if (index !== -1) {
                rects.push({
                    index,
                    left: rect.left,
                    right: rect.right,
                    top: rect.top,
                    bottom: rect.bottom
                });
            }
        });
        this._pillRects = rects;
    }
    _handlePointerMoveInput(e) {
        if (this._startedInInput && this._isDragging && this._dragStartPos) {
            this._currentMouseX = e.clientX;
            this._currentMouseY = e.clientY;
            const dx = e.clientX - this._dragStartPos.x;
            const distance = Math.abs(dx);
            if (distance > QueryBarSk.DRAG_THRESHOLD_PX) {
                this._hasDragged = true;
                const keys = this._sortKeys(Object.keys(this.query));
                const inputEl = e.currentTarget;
                const rect = inputEl.getBoundingClientRect();
                const isHorizontallyOutsideLeft = e.clientX < rect.left;
                const wasToTheLeft = this._isToTheLeft;
                this._isToTheLeft = isHorizontallyOutsideLeft;
                const textField = inputEl;
                var _textField_selectionStart;
                const selectionStart = (_textField_selectionStart = textField.selectionStart) !== null && _textField_selectionStart !== void 0 ? _textField_selectionStart : 0;
                var _textField_selectionEnd;
                const selectionEnd = (_textField_selectionEnd = textField.selectionEnd) !== null && _textField_selectionEnd !== void 0 ? _textField_selectionEnd : 0;
                if (!wasToTheLeft && isHorizontallyOutsideLeft) {
                    if (selectionStart === 0) {
                        this._canSelectPills = true;
                        this._savedEnd = selectionEnd;
                    }
                }
                let focusIndex = -1;
                if (this._canSelectPills) {
                    var _this_renderRoot_querySelector;
                    const anchorIndex = keys.length - 1;
                    this._selectionAnchor = anchorIndex;
                    const containerRect = (_this_renderRoot_querySelector = this.renderRoot.querySelector('.query-bar-container')) === null || _this_renderRoot_querySelector === void 0 ? void 0 : _this_renderRoot_querySelector.getBoundingClientRect();
                    focusIndex = calculatePillFocusIndex(e.clientX, e.clientY, containerRect, this._pillRects);
                    if (focusIndex !== -1) {
                        this._selectionFocus = focusIndex;
                        const start = Math.min(this._selectionAnchor, focusIndex);
                        const end = Math.max(this._selectionAnchor, focusIndex);
                        const newSelection = new Set();
                        for(let i = start; i <= end; i++){
                            newSelection.add(i);
                        }
                        this._selectedPills = newSelection;
                    } else {
                        this._selectionAnchor = null;
                        this._selectionFocus = null;
                        this._selectedPills = new Set();
                    }
                }
            }
        }
    }
    _handlePointerUpInput(e) {
        if (this._isDragging) {
            this._isDragging = false;
            this._dragStartPos = null;
            this._startedInInput = false;
            this._canSelectPills = false;
            const target = e.currentTarget;
            target.releasePointerCapture(e.pointerId);
        }
    }
    _handleFocusOutContainer(e) {
        const currentTarget = e.currentTarget;
        if (!currentTarget.contains(e.relatedTarget)) {
            this._selectionAnchor = null;
            this._selectionFocus = null;
            this._canSelectPills = false;
            this._selectedPills = new Set();
        }
    }
    _focusInput() {
        var _this__inputElement;
        (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.focus();
    }
    _handlePasteEvent(e) {
        var _e_clipboardData;
        const text = ((_e_clipboardData = e.clipboardData) === null || _e_clipboardData === void 0 ? void 0 : _e_clipboardData.getData('text')) || '';
        if (text.includes('=')) {
            if (this._inputValue === '' || this._selectionAnchor !== null && this._selectionFocus !== null) {
                e.preventDefault();
                this._handlePaste(text);
            }
        }
    }
    _handlePaste(text) {
        const tokens = text.match(/(?:[^\s"]+|"[^"]*")+/g) || [];
        tokens.forEach((token)=>{
            const eqIdx = token.indexOf('=');
            if (eqIdx !== -1) {
                const key = token.substring(0, eqIdx);
                const val = token.substring(eqIdx + 1);
                if (key && val) {
                    const vals = val.match(/(?:[^,"]+|"[^"]*")+/g) || [];
                    vals.forEach((v)=>{
                        const cleanedVal = v.replace(/^"|"$/g, '');
                        this._dispatchEvent('add-query', {
                            key,
                            value: cleanedVal
                        });
                    });
                }
            }
        });
    }
    _handleFocus() {
        this._isOpen = true;
        this._updateSuggestions();
        if (this.pendingPillSelection) {
            const keys = this._sortKeys(Object.keys(this.query));
            const idx = keys.indexOf(this.pendingPillSelection);
            if (idx !== -1) {
                this._selectionAnchor = idx;
                this._selectionFocus = idx;
                this._selectedPills = new Set([
                    idx
                ]);
                this._canSelectPills = true;
            }
            this.pendingPillSelection = null;
        }
    }
    _handleInputChange(e) {
        const val = e.target.value;
        this._inputValue = val;
        this._focusedIndex = 0;
        const trimmed = val.trim();
        this._isOpen = true;
        if (!trimmed) {
            this._selectedCategory = null;
        }
        this._updateSuggestions();
        this.dispatchEvent(new CustomEvent('suggest', {
            detail: {
                query: val
            },
            bubbles: true,
            composed: true
        }));
    }
    _handleKeyDown(e) {
        const keys = this._sortKeys(Object.keys(this.query));
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            this._handleArrowUpDown(e, keys);
        } else if (e.key === 'Enter') {
            this._handleEnter(e);
        } else if (e.key === 'Escape') {
            this._handleEscape();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            this._handleArrowLeftRight(e, keys);
        } else if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
            this._handleSelectAll(e, keys);
        } else if (e.key === 'c' && (e.ctrlKey || e.metaKey)) {
            this._handleCopy(e, keys);
        } else if (e.key === 'x' && (e.ctrlKey || e.metaKey)) {
            this._handleCut(e, keys);
        } else if (e.key === 'Backspace' || e.key === 'Delete') {
            this._handleBackspaceDelete(e, keys);
        } else {
            this._handleDefaultKey(e, keys);
        }
    }
    _handleArrowUpDown(e, keys) {
        e.preventDefault();
        const isDown = e.key === 'ArrowDown';
        if (this._isOpen && this._suggestions.length > 0) {
            const step = isDown ? 1 : -1;
            this._focusedIndex = (this._focusedIndex + step + this._suggestions.length) % this._suggestions.length;
            this._scrollFocusedIntoView();
        } else if (!this._isOpen) {
            const root = this.getRootNode();
            const bars = Array.from(root.querySelectorAll('query-bar-sk'));
            const idx = bars.indexOf(this);
            if (idx !== -1) {
                const step = isDown ? 1 : -1;
                const nextIdx = (idx + step + bars.length) % bars.length;
                const nextBar = bars[nextIdx];
                if (this._selectionAnchor !== null && this._selectionAnchor === this._selectionFocus) {
                    nextBar.pendingPillSelection = keys[this._selectionAnchor];
                }
                nextBar._focusInput();
            }
        }
    }
    _handleEnter(e) {
        var _this__inputElement, _this__inputElement1;
        e.preventDefault();
        if (this._isOpen && this._suggestions.length > 0) {
            const item = this._suggestions[this._focusedIndex];
            if (item) {
                this._handleSelect(item);
            }
        } else if (this._selectionAnchor !== null && this._selectionAnchor === this._selectionFocus && (this._inputValue === '' || ((_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.selectionStart) === ((_this__inputElement1 = this._inputElement) === null || _this__inputElement1 === void 0 ? void 0 : _this__inputElement1.selectionEnd))) {
            this._openPillIndex = this._selectionFocus;
        }
    }
    _handleEscape() {
        this._isOpen = false;
        this._selectionAnchor = null;
        this._selectionFocus = null;
        this._selectedPills = new Set();
    }
    _handleArrowLeftRight(e, keys) {
        var _this__inputElement;
        const isRight = e.key === 'ArrowRight';
        const isLeft = e.key === 'ArrowLeft';
        var _this__inputElement_selectionStart;
        const selectionStart = (_this__inputElement_selectionStart = (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.selectionStart) !== null && _this__inputElement_selectionStart !== void 0 ? _this__inputElement_selectionStart : 0;
        const isPillFocused = this._selectionAnchor !== null && this._selectionFocus !== null;
        const canNavigate = this._inputValue === '' || isLeft && selectionStart === 0 || isRight && isPillFocused;
        if (!canNavigate) return;
        e.preventDefault();
        if (keys.length === 0) return;
        let nextFocus = this._selectionFocus;
        if (nextFocus === null) {
            if (isRight) return;
            nextFocus = keys.length - 1;
        } else {
            const step = isRight ? 1 : -1;
            nextFocus = Math.max(0, Math.min(keys.length, nextFocus + step));
        }
        if (nextFocus === keys.length) {
            var _this__inputElement1;
            this._selectionAnchor = null;
            this._selectionFocus = null;
            this._selectedPills = new Set();
            (_this__inputElement1 = this._inputElement) === null || _this__inputElement1 === void 0 ? void 0 : _this__inputElement1.focus();
        } else {
            this._selectionFocus = nextFocus;
            if (!e.shiftKey) {
                this._selectionAnchor = nextFocus;
                this._selectedPills = new Set([
                    nextFocus
                ]);
            } else {
                if (this._selectionAnchor === null) {
                    this._selectionAnchor = keys.length - 1;
                }
                const start = Math.min(this._selectionAnchor, nextFocus);
                const end = Math.max(this._selectionAnchor, nextFocus);
                const newSelection = new Set();
                for(let i = start; i <= end; i++){
                    newSelection.add(i);
                }
                this._selectedPills = newSelection;
            }
        }
    }
    _handleSelectAll(e, keys) {
        var _this__inputElement;
        e.preventDefault();
        if (keys.length > 0) {
            this._selectionAnchor = keys.length - 1;
            this._selectionFocus = 0;
            const newSelection = new Set();
            for(let i = 0; i < keys.length; i++){
                newSelection.add(i);
            }
            this._selectedPills = newSelection;
        }
        (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.select();
    }
    _handleCopy(e, keys) {
        if (this._selectedPills.size > 0) {
            var _this__inputElement, _this__inputElement1;
            e.preventDefault();
            const selectedKeys = keys.filter((_, idx)=>this._selectedPills.has(idx));
            let text = selectedKeys.map((k)=>{
                const values = (this.query[k] || []).map((v)=>v.includes(' ') ? `"${v}"` : v);
                return `${k}=${values.join(',')}`;
            }).join(' ');
            var _this__inputElement_selectionStart;
            const textSelectionStart = (_this__inputElement_selectionStart = (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.selectionStart) !== null && _this__inputElement_selectionStart !== void 0 ? _this__inputElement_selectionStart : 0;
            var _this__inputElement_selectionEnd;
            const textSelectionEnd = (_this__inputElement_selectionEnd = (_this__inputElement1 = this._inputElement) === null || _this__inputElement1 === void 0 ? void 0 : _this__inputElement1.selectionEnd) !== null && _this__inputElement_selectionEnd !== void 0 ? _this__inputElement_selectionEnd : 0;
            if (textSelectionStart !== textSelectionEnd && this._inputValue !== '') {
                const selectedText = this._inputValue.substring(textSelectionStart, textSelectionEnd);
                if (text && selectedText) {
                    text += ' ' + selectedText;
                } else if (selectedText) {
                    text = selectedText;
                }
            }
            navigator.clipboard.writeText(text);
        }
    }
    _handleCut(e, keys) {
        if (this._selectedPills.size > 0) {
            var _this__inputElement, _this__inputElement1;
            this._handleCopy(e, keys);
            var _this__inputElement_selectionStart;
            const textSelectionStart = (_this__inputElement_selectionStart = (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.selectionStart) !== null && _this__inputElement_selectionStart !== void 0 ? _this__inputElement_selectionStart : 0;
            var _this__inputElement_selectionEnd;
            const textSelectionEnd = (_this__inputElement_selectionEnd = (_this__inputElement1 = this._inputElement) === null || _this__inputElement1 === void 0 ? void 0 : _this__inputElement1.selectionEnd) !== null && _this__inputElement_selectionEnd !== void 0 ? _this__inputElement_selectionEnd : 0;
            if (textSelectionStart !== textSelectionEnd && this._inputValue !== '') {
                this._inputValue = this._inputValue.substring(0, textSelectionStart) + this._inputValue.substring(textSelectionEnd);
            }
            const selectedKeys = keys.filter((_, idx)=>this._selectedPills.has(idx));
            selectedKeys.forEach((k)=>this._dispatchEvent('remove-key', {
                    key: k
                }));
            this._selectionAnchor = null;
            this._selectionFocus = null;
            this._selectedPills = new Set();
        }
    }
    _handleBackspaceDelete(e, keys) {
        const hasSelection = this._selectedPills.size > 0;
        if (hasSelection) {
            e.preventDefault();
            const selectedKeys = keys.filter((_, idx)=>this._selectedPills.has(idx));
            selectedKeys.forEach((k)=>this._dispatchEvent('remove-key', {
                    key: k
                }));
            this._selectionAnchor = null;
            this._selectionFocus = null;
            this._selectedPills = new Set();
        } else if (e.key === 'Backspace' && this._inputValue === '' && keys.length > 0) {
            e.preventDefault();
            const lastKey = keys[keys.length - 1];
            this._dispatchEvent('remove-key', {
                key: lastKey
            });
        }
    }
    _handleDefaultKey(e, keys) {
        if (this._selectionAnchor !== null && this._selectionFocus !== null) {
            const isModifier = e.ctrlKey || e.metaKey || e.altKey;
            const isNavigation = [
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ].includes(e.key);
            const isSelection = [
                'Shift',
                'Control',
                'Alt',
                'Meta'
            ].includes(e.key);
            if (!isModifier && !isNavigation && !isSelection && e.key.length === 1) {
                e.preventDefault();
                const selectedKeys = keys.filter((_, idx)=>this._selectedPills.has(idx));
                selectedKeys.forEach((k)=>this._dispatchEvent('remove-key', {
                        key: k
                    }));
                this._selectionAnchor = null;
                this._selectionFocus = null;
                this._selectedPills = new Set();
                this._inputValue = this._inputValue + e.key;
                this._isOpen = true;
                this._updateSuggestions();
            }
        }
    }
    _handleSelect(suggestion) {
        const p = suggestion.params[0];
        if (p.value === '') {
            this._selectedCategory = p.key;
            this._inputValue = `${p.key}=`;
            this.externalSuggestions = null; // Clear stale suggestions
            this._updateSuggestions();
            return;
        }
        suggestion.params.forEach((param)=>{
            this._dispatchEvent('add-query', {
                key: param.key,
                value: param.value
            });
        });
        this._inputValue = '';
        this._selectedCategory = null;
        this._isOpen = true;
        this.externalSuggestions = null; // Clear stale suggestions
        this._updateSuggestions();
        setTimeout(()=>{
            var _this__inputElement;
            return (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.focus();
        }, 0);
    }
    _handlePillChange(key, value) {
        const currentValues = this.query[key] || [];
        if (currentValues.includes(value)) {
            this._dispatchEvent('remove-query', {
                key,
                value
            });
        } else {
            this._dispatchEvent('add-query', {
                key,
                value
            });
        }
    }
    _handleReplace(key, value) {
        this._dispatchEvent('set-selected', {
            key,
            values: [
                value
            ]
        });
    }
    _scrollFocusedIntoView() {
        setTimeout(()=>{
            if (this._listElement && this._focusedIndex >= 0) {
                const item = this._listElement.children[this._focusedIndex];
                if (item) {
                    item.scrollIntoView({
                        block: 'nearest'
                    });
                }
            }
        }, 0);
    }
    _dispatchEvent(name, detail) {
        this.dispatchEvent(new CustomEvent(name, {
            detail,
            bubbles: true,
            composed: true
        }));
    }
    _sortOptions(options, selectedValues) {
        return [
            ...options
        ].sort((a, b)=>{
            const aSelected = selectedValues.includes(a.value);
            const bSelected = selectedValues.includes(b.value);
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            return b.count - a.count;
        });
    }
    _addPipelineStep(funcId) {
        const newPipeline = [
            ...this.pipeline,
            funcId
        ];
        this.pipeline = newPipeline;
        this._showFormulaPopover = false;
        this._dispatchEvent('pipeline-change', {
            pipeline: newPipeline
        });
    }
    _removePipelineStep(idx) {
        const newPipeline = this.pipeline.filter((_, i)=>i !== idx);
        this.pipeline = newPipeline;
        this._dispatchEvent('pipeline-change', {
            pipeline: newPipeline
        });
    }
    render() {
        var _window_perf, _window_perf1;
        const activePipeline = this.pipeline.length > 0 ? this.pipeline : this.formula && this.formula !== 'none' ? [
            this.formula
        ] : [];
        return (0, _lit.html)`
      <div
        class="query-bar-container"
        @click=${()=>{
            var _this__inputElement;
            return (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.focus();
        }}
        @focusout=${this._handleFocusOutContainer}>
        <div class="query-pills">
          ${(0, _repeat.repeat)(this._sortKeys(Object.keys(this.query)).map((key, idx)=>[
                key,
                this.query[key],
                idx
            ]), ([key])=>key, ([key, values, idx])=>{
            const options = this.optionsByKey[key] || [];
            const sortedOptions = this._sortOptions(options, values);
            return (0, _lit.html)`
                <explore-multi-v2-select-sk
                  @click=${(e)=>this._handlePillClick(e, idx)}
                  data-index=${idx}
                  .label=${key}
                  .variant=${'pill'}
                  .options=${sortedOptions}
                  .selected=${values}
                  .isSplit=${this.splitKeys.has(key)}
                  .isHighlighted=${this._isPillHighlighted(idx)}
                  .isOpen=${idx === this._openPillIndex}
                  .showSplitButton=${true}
                  .showDiffButton=${true}
                  .loading=${this.loading}
                  @open=${()=>{
                this._openPillIndex = idx;
                void this._handleMultiSelectOpen(key);
            }}
                  @close=${()=>{
                this._openPillIndex = null;
            }}
                  @close-with-esc=${()=>{
                var _this__inputElement;
                this._selectionAnchor = idx;
                this._selectionFocus = idx;
                this._openPillIndex = null;
                (_this__inputElement = this._inputElement) === null || _this__inputElement === void 0 ? void 0 : _this__inputElement.focus();
            }}
                  @selection-change=${(e)=>this._handlePillChange(key, e.detail.value)}
                  @set-selection=${(e)=>this._dispatchEvent('set-selected', {
                    key,
                    values: e.detail.values
                })}
                  @replace-selection=${(e)=>this._handleReplace(key, e.detail.value)}
                  @remove-key=${(e)=>{
                e.stopPropagation();
                this._dispatchEvent('remove-key', {
                    key
                });
            }}
                  @split=${()=>this._dispatchEvent('split', {
                    key
                })}
                  @diff-base=${(e)=>{
                e.stopPropagation();
                this._dispatchEvent('diff-base', e.detail);
            }}></explore-multi-v2-select-sk>
              `;
        })}

          <div class="query-input-wrapper">
            <md-outlined-text-field
              type="text"
              class="query-input"
              .value=${this._inputValue}
              @input=${this._handleInputChange}
              @keydown=${this._handleKeyDown}
              @focus=${this._handleFocus}
              @pointerdown=${this._handlePointerDownInput}
              @pointermove=${this._handlePointerMoveInput}
              @pointerup=${this._handlePointerUpInput}
              @paste=${this._handlePasteEvent}
              placeholder=${this._getPlaceholderTip()}
              @click=${(e)=>e.stopPropagation()}></md-outlined-text-field>
            ${this.loading ? (0, _lit.html)`<div class="input-spinner"></div>` : ''}
            ${this._isOpen && this._suggestions.length > 0 ? (0, _lit.html)`
                  <div class="suggestions-dropdown" @click=${(e)=>e.stopPropagation()}>
                    ${this._suggestions.map((s, idx)=>(0, _lit.html)`
                        <div
                          class="suggestion-item ${idx === this._focusedIndex ? 'focused' : ''}"
                          @click=${()=>this._handleSelect(s)}
                          @mouseenter=${()=>this._focusedIndex = idx}>
                          ${s.params.map((p)=>(0, _lit.html)`
                              <span class="suggestion-pill">
                                <span class="s-key">${p.key}</span>
                                <span class="s-sep">=</span>
                                <span class="s-val">${p.value}</span>
                              </span>
                            `)}
                          ${s.count !== undefined ? (0, _lit.html)`
                                <span class="s-count right ${this.loading ? 'stale' : ''}"
                                  >(${s.count.toLocaleString()}${s.countIsLowerBound ? '+' : ''})</span
                                >
                              ` : ''}
                        </div>
                      `)}
                  </div>
                ` : ''}
          </div>
        </div>

        <div class="query-actions" @click=${(e)=>e.stopPropagation()}>
          ${((_window_perf = window.perf) === null || _window_perf === void 0 ? void 0 : _window_perf.enable_only_regressions_option) ? (0, _lit.html)`
                <md-icon-button
                  class="qb-only-regressions-btn ${this.onlyRegressions ? 'active' : ''}"
                  @click=${(e)=>{
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('toggle-only-regressions', {
                bubbles: true,
                composed: true
            }));
        }}
                  title=${this.onlyRegressions ? 'Show all traces' : 'Filter to traces with regressions only'}
                  aria-label="Toggle only regressions">
                  <md-icon>${this.onlyRegressions ? 'filter_alt' : 'filter_alt_off'}</md-icon>
                </md-icon-button>
              ` : ''}
          ${((_window_perf1 = window.perf) === null || _window_perf1 === void 0 ? void 0 : _window_perf1.enable_split_all_option) ? (0, _lit.html)`
                <md-icon-button
                  class="qb-split-all-btn ${this.splitAll ? 'active' : ''}"
                  @click=${(e)=>{
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('toggle-split-all', {
                bubbles: true,
                composed: true
            }));
        }}
                  title=${this.splitAll ? 'Group traces into shared graphs' : 'Split every trace into its own graph'}
                  aria-label="Toggle split all traces">
                  <md-icon>${this.splitAll ? 'view_module' : 'grid_view'}</md-icon>
                </md-icon-button>
              ` : ''}
          <md-icon-button
            class="qb-clone-query-btn"
            @click=${(e)=>{
            e.stopPropagation();
            this._dispatchEvent('clone-query', {});
        }}
            title="Duplicate this query"
            aria-label="Duplicate this query">
            <md-icon>content_copy</md-icon>
          </md-icon-button>

          ${this.showRemoveQueryButton ? (0, _lit.html)`
                <md-icon-button
                  class="qb-remove-query-btn"
                  @click=${(e)=>{
            e.stopPropagation();
            this._dispatchEvent('clear-query', {});
        }}
                  title="Remove this query"
                  aria-label="Remove this query">
                  <md-icon>close</md-icon>
                </md-icon-button>
              ` : ''}

          <div class="qb-pipeline-container">
            ${activePipeline.map((step, idx)=>(0, _lit.html)`
                <span class="qb-pipeline-step">
                  ${step}()
                  <span
                    class="qb-pipeline-remove"
                    title="Remove this step"
                    @click=${(e)=>{
                e.stopPropagation();
                this._removePipelineStep(idx);
            }}
                    >&times;</span
                  >
                </span>
                ${idx < activePipeline.length - 1 ? (0, _lit.html)`<span class="qb-pipeline-arrow">&rarr;</span>` : ''}
              `)}

            <button
              class="qb-add-formula-btn"
              @click=${(e)=>{
            e.stopPropagation();
            this._showFormulaPopover = !this._showFormulaPopover;
        }}
              title="Add formula transformation step">
              ${activePipeline.length > 0 ? 'Add Step' : 'Formula'}
            </button>

            ${this._showFormulaPopover ? (0, _lit.html)`
                  <div class="qb-formula-popover" @click=${(e)=>e.stopPropagation()}>
                    ${[
            {
                id: 'prep',
                title: '1. Preprocessing'
            },
            {
                id: 'agg',
                title: '2. Aggregation'
            },
            {
                id: 'trans',
                title: '3. Transformation'
            }
        ].map((cat)=>(0, _lit.html)`
                        <div class="qb-formula-popover-header">${cat.title}</div>
                        <div class="qb-formula-grid">
                          ${FORMULA_OPTIONS.filter((f)=>f.category === cat.id).map((f)=>(0, _lit.html)`
                              <button
                                class="qb-formula-item"
                                @click=${(e)=>{
                    e.stopPropagation();
                    this._addPipelineStep(f.id);
                }}>
                                <span class="qb-formula-item-name">${f.name}</span>
                                <span class="qb-formula-item-desc">${f.desc}</span>
                              </button>
                            `)}
                        </div>
                      `)}
                  </div>
                ` : ''}
          </div>
        </div>
      </div>
    `;
    }
    constructor(...args){
        super(...args);
        this.pendingPillSelection = null;
        this.query = {};
        this.availableParams = [];
        this.optionsByKey = {};
        this.includeParams = [];
        this.defaults = null;
        this.splitKeys = new Set();
        this.showRemoveQueryButton = false;
        this.formula = 'none';
        this.pipeline = [];
        this.onlyRegressions = false;
        this.splitAll = false;
        this.externalSuggestions = null;
        this._showFormulaPopover = false;
        this.loading = false;
        this._inputValue = '';
        this._isOpen = false;
        this._focusedIndex = 0;
        this._suggestions = [];
        this._selectedCategory = null;
        this._selectionAnchor = null;
        this._selectionFocus = null;
        this._isDragging = false;
        this._dragStartPos = null;
        this._startedInInput = false;
        this._pillRects = [];
        this._canSelectPills = false;
        this._openPillIndex = null;
        this._selectedPills = new Set();
        this._isToTheLeft = false;
        this._savedEnd = 0;
        this._currentMouseX = 0;
        this._currentMouseY = 0;
        this._hasDragged = false;
        this._handleClickOutside = (e)=>{
            const path = e.composedPath();
            if (this._isOpen && !path.includes(this)) {
                this._isOpen = false;
            }
            if (this._showFormulaPopover && !path.includes(this)) {
                this._showFormulaPopover = false;
            }
        };
        this._handleSelectionChange = ()=>{
            var _this_shadowRoot;
            const activeEl = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.activeElement;
            if (activeEl === this._inputElement) {
                const textField = this._inputElement;
                const start = textField.selectionStart || 0;
                const end = textField.selectionEnd || 0;
                if (start > 0 || start === end && textField.value !== '') {
                    this._canSelectPills = false;
                    this._selectionAnchor = null;
                    this._selectionFocus = null;
                    this._selectedPills = new Set();
                }
            }
        };
    }
}, (()=>{
    _QueryBarSk.DRAG_THRESHOLD_PX = 5;
})(), (()=>{
    _QueryBarSk.styles = (0, _lit.css)`
    :host {
      display: block;
      font-family: Roboto, sans-serif;
    }

    .query-bar-container {
      background: var(--md-sys-color-surface);
      border: 1px solid var(--md-sys-color-outline);
      border-radius: 4px;
      padding: 4px 8px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      cursor: text;
      box-shadow: none;
      transition: all 0.2s ease;
    }

    .query-bar-container:focus-within {
      border-color: var(--md-sys-color-primary);
      box-shadow: 0 0 0 1px var(--md-sys-color-primary);
    }

    .query-pills {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      flex: 1;
      align-items: center;
    }

    .query-input-wrapper {
      flex: 1;
      position: relative;
      min-width: 150px;
      align-self: center;
      display: flex;
      align-items: center;
      padding: 2px 0;
    }

    .query-input {
      --md-outlined-text-field-outline-color: transparent;
      --md-outlined-text-field-focus-outline-color: transparent;
      --md-outlined-text-field-container-color: transparent;
      --md-outlined-text-field-input-text-color: var(--on-surface);

      width: 100%;
      flex: 1;
      font-size: 13px;
    }

    .query-input::placeholder {
      color: var(--md-sys-color-on-surface-variant);
      font-style: normal;
    }

    .input-spinner {
      width: 14px;
      height: 14px;
      border: 2px solid var(--md-sys-color-outline-variant);
      border-top-color: var(--md-sys-color-primary);
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
      margin-right: 6px;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    .suggestions-dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      min-width: 350px;
      max-height: 450px;
      overflow-y: auto;
      background: var(--md-sys-color-surface);
      border: 1px solid var(--md-sys-color-outline-variant);
      border-radius: 4px;
      box-shadow: 0 4px 12px color-mix(in srgb, var(--transparent-overlay) 20%, transparent);
      z-index: 1000;
      margin-top: 4px;
      padding: 4px 0;
    }

    .suggestion-item {
      padding: 6px 12px;
      cursor: pointer;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 6px;
      font-family: monospace;
      font-size: 12px;
      transition: background-color 0.2s;
      color: var(--on-surface);
    }

    .suggestion-item.info {
      color: var(--md-sys-color-on-surface-variant);
      font-style: italic;
      cursor: default;
    }

    .suggestion-item:hover,
    .suggestion-item.focused {
      background-color: color-mix(in srgb, var(--on-surface) 10%, transparent);
    }

    .suggestion-pill {
      display: inline-flex;
      align-items: center;
      background: color-mix(in srgb, var(--on-surface) 15%, transparent);
      border-radius: 10px;
      padding: 1px 8px;
      font-size: 11px;
      max-width: 100%;
    }

    .s-key {
      color: var(--md-sys-color-on-surface-variant);
    }

    .s-sep {
      color: var(--md-sys-color-outline);
      margin: 0 2px;
    }

    .s-val {
      color: var(--on-surface);
      font-weight: 500;
    }

    .s-count.right {
      margin-left: auto;
      color: var(--md-sys-color-on-surface-variant);
      font-style: italic;
      font-size: 10px;
    }

    .s-count.stale {
      opacity: 0.5;
    }

    .query-actions {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-left: auto;
    }

    .qb-clone-query-btn,
    .qb-remove-query-btn {
      background: none;
      border: none;
      color: var(--md-sys-color-on-surface-variant);
      font-size: 16px;
      cursor: pointer;
      padding: 0 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      transition: background-color 0.2s;
    }

    .qb-clone-query-btn:hover,
    .qb-remove-query-btn:hover {
      background-color: var(--md-sys-color-surface-container-highest);
    }

    .qb-formula-select {
      background: var(
        --surface-variant,
        var(--surface, var(--md-sys-color-surface-container-high))
      );
      border: 1px solid var(--outline, var(--border, var(--md-sys-color-outline-variant)));
      color: var(--on-surface, var(--on-background, var(--md-sys-color-on-surface)));
      border-radius: 6px;
      padding: 3px 8px;
      font-size: 11px;
      font-weight: 600;
      cursor: pointer;
      outline: none;
      height: 28px;
      box-sizing: border-box;
    }

    .qb-formula-select option {
      background-color: var(--surface, var(--background, var(--md-sys-color-surface)));
      color: var(--on-surface, var(--md-sys-color-on-surface));
    }

    .qb-formula-select:hover,
    .qb-formula-select:focus {
      border-color: var(--primary, var(--md-sys-color-primary));
    }

    .qb-pipeline-container {
      display: flex;
      align-items: center;
      gap: 6px;
      background: var(
        --md-sys-color-surface-container-low,
        var(--surface-container-low, var(--background))
      );
      border: 1px solid var(--md-sys-color-outline-variant, var(--border));
      border-radius: 8px;
      padding: 3px 8px;
      position: relative;
    }

    .qb-pipeline-step {
      font-size: 11px;
      font-weight: 600;
      border-radius: 4px;
      padding: 2px 8px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: color-mix(in srgb, var(--md-sys-color-primary, var(--primary)) 20%, transparent);
      color: var(--md-sys-color-primary, var(--primary));
      border: 1px solid
        color-mix(in srgb, var(--md-sys-color-primary, var(--primary)) 40%, transparent);
    }

    .qb-pipeline-arrow {
      color: var(--md-sys-color-on-surface-variant);
      font-size: 10px;
    }

    .qb-pipeline-remove {
      font-size: 14px;
      line-height: 1;
      color: var(--md-sys-color-on-surface-variant);
      cursor: pointer;
      margin-left: 2px;
    }

    .qb-pipeline-remove:hover {
      color: var(--md-sys-color-error, var(--error));
    }

    .qb-add-formula-btn {
      background: color-mix(in srgb, var(--on-surface) 10%, transparent);
      border: 1px dashed color-mix(in srgb, var(--on-surface) 30%, transparent);
      color: var(--on-surface);
      font-size: 11px;
      font-weight: 500;
      border-radius: 4px;
      padding: 3px 8px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      transition: all 0.2s ease;
    }

    .qb-add-formula-btn:hover {
      background: color-mix(in srgb, var(--primary) 20%, transparent);
      border-color: var(--primary);
      color: var(--primary);
    }

    .qb-formula-popover {
      position: absolute;
      right: 0;
      top: 42px;
      width: 320px;
      max-width: calc(100vw - 32px);
      max-height: 380px;
      overflow-y: auto;
      background: var(--surface);
      border: 1px solid color-mix(in srgb, var(--on-surface) 15%, transparent);
      border-radius: 8px;
      box-shadow: none;
      padding: 14px;
      z-index: 2000;
    }

    .qb-formula-popover-header {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: var(--primary);
      margin: 10px 0 6px;
    }

    .qb-formula-popover-header:first-child {
      margin-top: 0;
    }

    .qb-formula-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 4px;
    }

    .qb-formula-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 8px 10px;
      background: color-mix(in srgb, var(--on-surface) 5%, transparent);
      border: 1px solid color-mix(in srgb, var(--on-surface) 12%, transparent);
      border-radius: 6px;
      cursor: pointer;
      text-align: left;
      transition: all 0.2s ease;
    }

    .qb-formula-item:hover {
      background: color-mix(in srgb, var(--primary) 15%, transparent);
      border-color: var(--primary);
    }

    .qb-formula-item-name {
      font-size: 12px;
      font-weight: 600;
      color: var(--on-surface);
      font-family: monospace;
    }

    .qb-formula-item-desc {
      font-size: 11px;
      color: color-mix(in srgb, var(--on-surface) 75%, transparent);
      margin-top: 2px;
    }
  `;
})(), _QueryBarSk);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record)
], QueryBarSk.prototype, "query", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], QueryBarSk.prototype, "availableParams", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", typeof Record === "undefined" ? Object : Record)
], QueryBarSk.prototype, "optionsByKey", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], QueryBarSk.prototype, "includeParams", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", Object)
], QueryBarSk.prototype, "defaults", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", typeof Set === "undefined" ? Object : Set)
], QueryBarSk.prototype, "splitKeys", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], QueryBarSk.prototype, "showRemoveQueryButton", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    })
], QueryBarSk.prototype, "formula", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], QueryBarSk.prototype, "pipeline", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], QueryBarSk.prototype, "onlyRegressions", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], QueryBarSk.prototype, "splitAll", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Object)
], QueryBarSk.prototype, "externalSuggestions", void 0);
_ts_decorate([
    (0, _decorators.state)()
], QueryBarSk.prototype, "_showFormulaPopover", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], QueryBarSk.prototype, "loading", void 0);
_ts_decorate([
    (0, _decorators.state)()
], QueryBarSk.prototype, "_inputValue", void 0);
_ts_decorate([
    (0, _decorators.state)()
], QueryBarSk.prototype, "_isOpen", void 0);
_ts_decorate([
    (0, _decorators.state)()
], QueryBarSk.prototype, "_focusedIndex", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], QueryBarSk.prototype, "_suggestions", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], QueryBarSk.prototype, "_selectedCategory", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], QueryBarSk.prototype, "_selectionAnchor", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], QueryBarSk.prototype, "_selectionFocus", void 0);
_ts_decorate([
    (0, _decorators.state)()
], QueryBarSk.prototype, "_isDragging", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], QueryBarSk.prototype, "_dragStartPos", void 0);
_ts_decorate([
    (0, _decorators.state)()
], QueryBarSk.prototype, "_startedInInput", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Array)
], QueryBarSk.prototype, "_pillRects", void 0);
_ts_decorate([
    (0, _decorators.state)()
], QueryBarSk.prototype, "_canSelectPills", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Object)
], QueryBarSk.prototype, "_openPillIndex", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof Set === "undefined" ? Object : Set)
], QueryBarSk.prototype, "_selectedPills", void 0);
_ts_decorate([
    (0, _decorators.query)('.query-input'),
    _ts_metadata("design:type", typeof HTMLInputElement === "undefined" ? Object : HTMLInputElement)
], QueryBarSk.prototype, "_inputElement", void 0);
_ts_decorate([
    (0, _decorators.query)('.suggestions-dropdown'),
    _ts_metadata("design:type", typeof HTMLDivElement === "undefined" ? Object : HTMLDivElement)
], QueryBarSk.prototype, "_listElement", void 0);
QueryBarSk = _ts_decorate([
    (0, _decorators.customElement)('query-bar-sk')
], QueryBarSk);
